"use client";
import React, { useEffect } from "react";

declare const window: Window &
  typeof globalThis & {
    hbspt: any;
  };

interface FormProps {
  formId?: string;
}

const HubspotContactForm = ({
  formId = "23bc8257-b548-422c-b1f2-183f533a1bf5"
}: FormProps) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js?pre=1";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "21417672",
          formId,
          target: "#hubspotForm"
        });
      }
    });
  }, [formId]);

  return (
    <div>
      <div id="hubspotForm"></div>
    </div>
  );
};

export default HubspotContactForm;
